import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "David Heinemeier Hansson is wrong! Startups work.",
  "description": "",
  "published": "2010-03-26T00:00:00.000Z",
  "redirect_from": ["/blog/?p=1261"],
  "categories": "Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`blahblah, write examples of startups that have created this whole thing we call western society`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      